import { makeAutoObservable } from "mobx";
import IContactInfo from "../interfaces/IContactInfo";

export default class PropertyContactInfoStore {
    isLoadingFor: { [id: string]: boolean } = {};
    isErrorFor: { [id: string]: boolean } = {};
    contactInfoFor: { [id: string]: IContactInfo } = {};

    constructor() {
        makeAutoObservable(this);
    }

    setIsLoadingFor(id: string, value: boolean) {
        this.isLoadingFor[id] = value;
    }

    getIsLoadingFor(id: string | undefined) {
        return id ? this.isLoadingFor[id] ?? false : false;
    }

    setIsErrorFor(id: string, value: boolean) {
        this.isErrorFor[id] = value;
    }

    getIsErrorFor(id: string | undefined) {
        return id ? this.isErrorFor[id] ?? false : false;
    }

    setContactInfoFor(id: string, contactInfo: IContactInfo) {
        this.contactInfoFor[id] = contactInfo;
    }

    getContactInfoFor(id: string) {
        return this.contactInfoFor[id];
    }

    clear() {
        this.contactInfoFor = {};
        this.isLoadingFor = {};
        this.isErrorFor = {};
    }
}
